import React from 'react';
import { Modal } from 'react-bootstrap';

// ********************************************** //
//  To use, populate with following props :
//  show_condition : bool
// 	handleCancelPrompt()
//	handleConfirmPrompt()
//  **** NOTE : If anchor is provided, onClick will be ignored. (use one or the other) ****
//  anchor
//  href
//  anchor_text
//  type ('warning', 'success', etc)
//	title
//	body
//	confirm_button_text
//	cancel_button_text
//  hide_cancel_button
//	bsSize
//  customClass

class ConfirmationPrompt extends React.Component {
    constructor(props) {
        super(props);

        this.cancel = this.cancel.bind(this);
        this.confirm = this.confirm.bind(this);
        this.enterCheck = this.enterCheck.bind(this)
    }
    cancel() {
    	this.props.handleCancelPrompt();
    }
    confirm() {
    	this.props.handleConfirmPrompt();
    }
    enterCheck(e) {
      e.stopPropagation();
      if(e.key === 'Enter') {
        this.props.handleConfirmPrompt();
      }
    }
    componentDidMount() {
      if(this.props.show_condition === true) {
        $(window).on('keydown', this.enterCheck);
      }
    }
    componentWillUpdate(next_props) {
      if(this.props.show_condition === false && next_props.show_condition === true) {
        $(window).on('keydown', this.enterCheck);
      }
      else if(this.props.show_condition === true && next_props.show_condition === false) {
        $(window).off('keydown', this.enterCheck);
      }
    }

    componentWillUnmount() {
      $(window).off('keydown', this.enterCheck);
    }

    render() {
      let _self = this;
      return (
  				<Modal
        		show={this.props.show_condition}
        		onHide={this.cancel}
        		bsSize={this.props.bsSize || 'lg'}
        		dialogClassName={this.props.customClass || ''}
        		>
		        <div className='confirmation-prompt-container'>
	        		<div className={`panel panel-${this.props.type || 'warning'} mb-none`}>
	        			<div className='panel-heading'>
	        				<h4>{this.props.title}</h4>
	        			</div>
	        			<Modal.Body className='panel-body'>
	      					<p>{this.props.body}</p>
	      					<div className='row'>
		        				<div className='pull-right mb-sm'>
		        					<div className='col-md-12'>
                        {(() => {
                          if(_self.props.anchor_href) {
                            return (
                              <a
                                href={_self.props.anchor_href}
                                onClick={_self.props.onClick}
                                className={`btn btn-${_self.props.type || 'warning'} mr-sm`}
                                target='_blank'
                                >
                                {_self.props.confirm_button_text || 'Confirm'}
                              </a>
                            )
                          }
                          else {
                            return (
                              <div
                                onClick={_self.confirm}
                                className={`btn btn-${_self.props.type || 'warning'} mr-sm`}
                                tabIndex='0'
                                >
                                {_self.props.confirm_button_text || 'Confirm'}
                              </div>
                            )
                          }
                        })()}
                        {!this.props.hide_cancel_button ? (
                          <div
  		        							onClick={this.cancel}
  		        							className='btn btn-default'>
  		        								{this.props.cancel_button_text || 'Cancel'}
  		        						</div>
                        ) : null}
		        					</div>
	        					</div>
	      					</div>
	        			</Modal.Body>
		        	</div>
	        	</div>
        	</Modal>
      );
    }
}

export default ConfirmationPrompt;



// WEBPACK FOOTER //
// ./src/browser/components/ui/confirmationPrompt.js